import { z } from 'zod'

export const EmailTemplateSchema = z.object({
	id: z.string(),
	name: z.string(),
	type: z.string(),
	subject: z.record(z.string()),
	active: z.boolean(),
	storeId: z.string(),
	accountId: z.string().nullable().optional(),
	params: z
		.object({
			replyTo: z.string().optional(),
			specific: z.record(z.string()).optional(),
		})
		.optional(),
	templateVariables: z
		.record(
			z.record(
				z.record(
					// Leaf is usually an HTML string per locale (eg. body.en),
					// but can also be a Tiptap JSONContent object for bodyJson.<locale>.
					z.union([z.string(), z.record(z.any())]),
				),
			),
		)
		.optional(),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
	store: z
		.object({
			id: z.string(),
			name: z.string(),
			emailDomains: z
				.array(
					z.object({
						fromEmail: z.string(),
					}),
				)
				.optional(),
		})
		.optional(),
})

export type EmailTemplateType = z.infer<typeof EmailTemplateSchema>

export const toEmailTemplateDto = (data: any): EmailTemplateType => {
	return EmailTemplateSchema.parse({
		...data,
		params: data.params ?? {},
		templateVariables: data.templateVariables ?? {},
	})
}

